import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Certifications icon.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const CertificationsIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    <path
      d="M14.167 7.33301C14.167 5.03193 12.302 3.16619 10.001 3.16602C7.69979 3.16602 5.83398 5.03182 5.83398 7.33301C5.83416 9.63404 7.6999 11.499 10.001 11.499C10.8256 11.499 11.5933 11.2581 12.2402 10.8447C12.2562 10.8335 12.2727 10.8229 12.29 10.8135C13.4206 10.0684 14.1669 8.78823 14.167 7.33301ZM12.127 12.041C11.4784 12.3344 10.7591 12.499 10.001 12.499C9.24263 12.499 8.52277 12.3345 7.87402 12.041L7.29883 16.3701L9.74316 14.9043L9.80469 14.873C9.95077 14.8107 10.1193 14.8212 10.2578 14.9043L12.7012 16.3701L12.127 12.041ZM15.167 7.33301C15.1669 9.03945 14.3389 10.5514 13.0635 11.4922L13.8301 17.2666C13.8553 17.4569 13.7689 17.6456 13.6084 17.751C13.4481 17.8561 13.2416 17.8602 13.0771 17.7617L10 15.916L6.9248 17.7617C6.76018 17.8605 6.55305 17.8564 6.39258 17.751C6.23211 17.6456 6.1466 17.4569 6.17188 17.2666L6.93848 11.4932C5.66251 10.5525 4.83409 9.03985 4.83398 7.33301C4.83398 4.47954 7.14751 2.16602 10.001 2.16602C12.8543 2.16619 15.167 4.47965 15.167 7.33301Z"
      fill="currentColor"
    />
  </svg>
);

export default CertificationsIcon;
